// NOTE: function to queue the apstag calls before the library load, the original load the library too(https://ams.amazon.com/webpublisher/docs/help/web-integration-documentation/integration-guide/javascript-guide/display.html)
(function IIFE(apstagGlobalName, root) {
  if (root[apstagGlobalName]) return;
  function queue(c, r) {
    root[apstagGlobalName]._Q.push([c, r]);
  }
  root[apstagGlobalName] = {
    init: function() {
      queue('i', arguments);
    },
    fetchBids: function() {
      queue('f', arguments);
    },
    setDisplayBids: function() {},
    targetingKeys:  function() {
      return [];
    },
    _Q:[]
  };
}('apstag', window));



// WEBPACK FOOTER //
// ./src/header-bidding/providers/amazon-script.js